"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BaseWidgetController_1 = require("../BaseWidgetController");
var loggers_1 = require("../../loggers");
var TranslationsController = /** @class */ (function (_super) {
    tslib_1.__extends(TranslationsController, _super);
    function TranslationsController(controllerConfig, translationsUrl) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.translationsUrl = translationsUrl;
        return _this;
    }
    TranslationsController.prototype.pageReady = function ($w, wixAPI) {
        return tslib_1.__awaiter(this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    TranslationsController.prototype.loadTranslations = function () {
        var _this = this;
        return fetch(this.translationsUrl)
            .then(function (res) { return res.json(); })
            .catch(function (e) {
            return loggers_1.ConsoleLogger.log("Error fetching translations for " + _this.translationsUrl + ".\n", e);
        });
    };
    TranslationsController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var props, _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        props = { translation: undefined };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        _a = props;
                        return [4 /*yield*/, this.loadTranslations()];
                    case 2:
                        _a.translation = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _b.sent();
                        loggers_1.ConsoleLogger.log('Translations controller error', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, props];
                }
            });
        });
    };
    return TranslationsController;
}(BaseWidgetController_1.BaseWidgetController));
exports.TranslationsController = TranslationsController;
//# sourceMappingURL=TranslationsController.js.map